const exampleStore = {};
export default exampleStore;